import { isNativePlatform } from './runtime'

/**
 * Canonical external origin for links this app produces itself — QR, NFC and
 * invite links (#1690, addendum §5.1: "כל קישור חיצוני נבנה מ-PUBLIC_APP_ORIGIN
 * קנוני. אין להפיק QR, NFC, הזמנה או קישור מ-window.location.origin בתוך
 * המעטפת.").
 *
 * On web this is `window.location.origin`, unchanged from today. Inside a
 * native build `window.location.origin` resolves to the WebView's internal
 * scheme (e.g. `capacitor://localhost`), never a real HTTPS origin another
 * phone's camera or NFC reader could open — so native must use an explicit,
 * configured value instead.
 *
 * Shai has not delivered a final production PUBLIC_APP_ORIGIN yet (spec
 * addendum §10: "PUBLIC_APP_ORIGIN ו-Associated Domains | פתוח למסירה"), so
 * there is nothing safe to hardcode. Until REACT_APP_PUBLIC_APP_ORIGIN is set
 * at native build time this returns '' and logs loudly — per spec.md §2.1
 * ("אין לאפשר כשל שקט"), silently falling back to the WebView's own origin
 * would be exactly the bug this function exists to prevent.
 */
export function getPublicAppOrigin() {
  const configured = process.env.REACT_APP_PUBLIC_APP_ORIGIN
  if (configured) {
    return configured
  }

  if (isNativePlatform()) {
    console.error(
      '[platform] REACT_APP_PUBLIC_APP_ORIGIN is not configured — external ' +
      "links built inside the native app would otherwise use the WebView's " +
      'internal origin (addendum §5.1). Set it before shipping a native build.'
    )
    return ''
  }

  return typeof window !== 'undefined' && window.location ? window.location.origin : ''
}
